import AgentActivity from 'models/agent_activity';
import SetAndLogActivity from 'actions/agent_activity/set_and_log_activity';
import setAgentPreferences from 'actions/agent_preferences/set_agent_preferences';
import { SidePanelType } from 'models/side_panel';

export default class OpenTeamAssistPanel {
  constructor(context) {
    this.context = context;
  }

  run({ customerId, conversationId, compositionId }) {
    const sidePanel = this.context.stores.sidePanel.get();
    if (!sidePanel.isShowing(SidePanelType.AI_ASSIST)) {
      sidePanel.show(SidePanelType.AI_ASSIST);
      this.context.stores.sidePanel.set(sidePanel);

      const preferences = this.context.stores.agentPreferences.get();
      preferences.setSidePanel(sidePanel);
      setAgentPreferences(this.context, preferences);

      // Server-side activity ping (parallel to the FullStory event below).
      // Mirrors the TASK_COMMENT_PANEL_OPEN pattern; supernova reads this
      // for SLA / liveboard reporting. Gated by the isShowing check so a
      // redundant open call doesn't double-emit.
      this.context.executeAction(SetAndLogActivity, {
        type: AgentActivity.Type.TEAM_ASSIST_PANEL_OPEN,
      });
    }

    this.context.analytics.track('Team Assist Panel Opened', { customerId, conversationId, compositionId });
  }
}
